import $ from 'jquery';
import 'velocity-animate';
import 'rangeslider.js';

import config from './globals/config';

import videoPlayerStart from './video-player-start';

export default function (
  handle,
  headerContainer,
  trailerDrawerBG,
  innerWrap,
  desktopDrawer,
  playerLightbox,
  leftOffCanvasMenu,
  loadingSpinner
) {
  // hack for sticky header, only for desktop
  if (!config.isiPad && !config.isAndroid) {
    headerContainer.css({ 'right': 'inherit', 'left': 'inherit' });
  } else {
    $('.exit-off-canvas').velocity({ opacity: 1 }, { duration: 750, delay: 750 });
  }

  // stop trailerDrawerRotation
  trailerDrawerBG.velocity('stop').css('transform', 'translateX(0)');
  config.trailerDrawerIsRotating = false;

  $('.drawer-info-container .drawer-info').velocity({ opacity: 0 }, { duration: 200, display: 'none' });

  function startPlayer () {
    let videoId = desktopDrawer.data('video-id');

    playerLightbox.removeClass('player-hide').addClass('player-show');

    playerLightbox.velocity('player-lightbox-show-desktop', {
      complete: function () {
        config.trailerDrawerIsAnimating = false;
        videoPlayerStart(loadingSpinner, videoId, 'main');
      },
    });
  }

  // animating innerWrap is too much for tablets
  if (!config.isiPad && !config.isAndroid) {
    innerWrap.velocity({ left: '80vw' }, {
      duration: config.drawerSlideTiming,
      easing  : config.easing,
      complete: startPlayer,
    });
  } else {
    startPlayer();
  }

  handle.velocity({
    left: '80vw',
  }, {
    duration: config.drawerSlideTiming,
    easing  : config.easing,
  });

  leftOffCanvasMenu.velocity({
    left : '-10vw',
    width: '100%',
  }, {
    duration: config.drawerSlideTiming,
    easing  : config.easing,
  });
}
